export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7072.d119acd0.jpg";